







import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class JenisNyeri extends Vue {
  @Prop() setJenisNyeri!: string;
  // jenis = "";

  // @Watch("jenis")
  // changeJenis(val) {
  //   this.$emit("jenisNyeri", val);
  // }

  @Watch("setJenisNyeri")
  valJenis(val) {
    this.$emit("jenisNyeri", val);
    this.setJenisNyeri = val;
  }
}
